import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useSvgId } from '../../primitives/useSvgId.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Search — magnifier with a scanning line clipped inside the lens,
 *  plus a static catchlight suggesting glass. */
export function IcnSearch(props: IconProps): ReactNode {
  const clipId = useSvgId('search-clip');
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="search">
      <defs>
        <clipPath id={clipId}>
          <circle cx="7" cy="7" r="4.5" />
        </clipPath>
      </defs>
      <circle cx="7" cy="7" r="4.5" />
      <g clipPath={`url(#${clipId})`}>
        {animate && (
          <line x1="3" y1="2" x2="3" y2="12" opacity="0.45">
            <animate attributeName="x1" values="3;11;3" dur="2.4s" repeatCount="indefinite" />
            <animate attributeName="x2" values="3;11;3" dur="2.4s" repeatCount="indefinite" />
          </line>
        )}
        <path d="M5 5.5a2 2 0 0 1 1.5-1" opacity="0.55" strokeLinecap="round" />
      </g>
      <path d="M10.5 10.5l3 3" />
    </Svg>
  );
}
